import Dispatcher from "../Dispatcher";
import LoadObjectState from "../../load_objects/LoadObjectState";
import { Action } from "../Actions";
import { ReduceStore } from "flux/utils";
import axios from "axios";
import LoadObject from "../../load_objects/LoadObject";
import { Fixture } from "../records/Fixture";
import FixtureDataManager from "../dataManagers/FixtureDataManager";
import _ = require("lodash");

interface IState {
    fixture: Fixture | null;
    fixtures: Array<Fixture> | null;
    requestId: string | null;
}

const emptyState: IState = {
    fixture: null,
    fixtures: null,
    requestId: null
};

class FixtureStore extends ReduceStore<LoadObjectState<IState>, Action> {
    private static readonly REFRESH_DELAY = 10000;


    constructor() {
        super(Dispatcher);
    }

    public getInitialState(): LoadObjectState<IState> {
        return new LoadObjectState(() => { });
    }

    public getStateSafely(): IState {
        return this.unwrap(super.getState());
    }

    public reduce(stateLoader: LoadObjectState<IState>, action: Action): LoadObjectState<IState> {
        const state = this.unwrap(stateLoader);

        switch (action.type) {
            case "fixture/start-load": {
                FixtureDataManager.getFixture(action.fixtureId);
                return stateLoader.setLoadObject(LoadObject.loading<IState>());
            }

            case "fixture/loaded": {
                let fixture = action.fixture;
                return this.wrap(stateLoader, { ...state, fixture: fixture });
            }

            case "fixture/error": {
                return stateLoader;
            }

            case "fixtures/start-load": {
                let from = action.from;
                let to = action.to;
                FixtureDataManager.getFixtures(from, to, action.requestId);
                return stateLoader.setLoadObject(LoadObject.withValue({...state, fixtures: null, requestId: action.requestId}).loading());
            }

            case "fixtures/start-refresh": {
                let from = action.from;
                let to = action.to;
                FixtureDataManager.getFixturesRefresh(from, to, action.requestId)
                return stateLoader.setLoadObject(LoadObject.withValue({ ...state}).updating());
            }

            case "fixtures/loaded": {
                if (!state.requestId || state.requestId === action.requestId) {
                    let fixtures = action.fixtures;
                    _.defer(() => Dispatcher.dispatch({
                        type: "fixtures/start-refresh",
                        requestId: action.requestId,
                        from: action.from,
                        to: action.to,
                        timeStamp: new Date()
                    }));

                    return this.wrap(stateLoader, { ...state, fixtures: fixtures });
                } else {
                    return stateLoader;
                }
                }

            case "fixtures/refreshed": {
                    if(action.requestId !== state.requestId) {
                        return stateLoader;
                    }

                    let fixtures = action.fixtures;
                    const delayDiff: number = action.timeStamp.getTime() - new Date().getTime() + FixtureStore.REFRESH_DELAY;
                    setTimeout(() => Dispatcher.dispatch({type: "fixtures/start-refresh", from: action.from, to: action.to, requestId: action.requestId, timeStamp: new Date()}), delayDiff > 0 ? delayDiff : 0);
                    return this.wrap(stateLoader, {...state,fixtures: fixtures});
                }


            case "fixtures/error":{
                    return stateLoader;
            }

            default:
                return stateLoader;
        }
    }

    private unwrap(state: LoadObjectState<IState>): IState {
        const lo = state.getLoadObject();
        if (!lo) {
            return emptyState;
        }

        if (!lo.hasValue()) {
            return emptyState;
        }

        return lo.getValue() || emptyState;
    }

    private wrap(loader: LoadObjectState<IState>, state: IState): LoadObjectState<IState> {
        return loader.setLoadObject(LoadObject.withValue(state));
    }

    private wrapWithError(loader: LoadObjectState<IState>, state: IState, error: Error): LoadObjectState<IState> {
        return loader.setLoadObject(LoadObject.withValue(state).setError(error));
    }
}

export default new FixtureStore();